import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=2e186af2"
import script from "./BusinessProfile.vue?vue&type=script&lang=js"
export * from "./BusinessProfile.vue?vue&type=script&lang=js"
import style0 from "./BusinessProfile.vue?vue&type=style&index=0&id=2e186af2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports